import { makeStyles } from '@material-ui/core';
import KoneLogo from './logo/kone-logo.svg';

const useStyles = makeStyles({
  svg: {
    width: 30,
    height: 'auto',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return <img className={classes.svg} src={KoneLogo} alt="KONE logo" />;
};

export default LogoIcon;
